import React from 'react';
import { useTranslation } from 'react-i18next';
import TooltipOverlay from '../tooltip/Tooltip';

interface FlagProps {
    code?: string;
    className?: string;
    size?: '1x1' | '4x3';
    width?: number;
    height?: number;
    placement?: 'top' | 'bottom' | 'right' | 'left';
}

const Flag: React.FC<FlagProps> = ({ code, className = '', size = '4x3', width, height, placement = 'right' }) => {
    const { t } = useTranslation();
    if (!code) return null;

    return (
        <TooltipOverlay placement={placement} content={t(`general.countries.${code}`)}>
            <img
                tabIndex={0}
                className={`cursor-pointer ${className}`}
                src={'/flags/' + size + '/' + code?.toLocaleLowerCase() + '.svg'}
                alt={t(`general.countries.${code}`)}
                width={width}
                height={height}
            />
        </TooltipOverlay>
    );
};

export default Flag;
